import { IFilterOptions } from "../useAssetTree";
import OptionsTreeWithUngrouped, { IOptionsTreeConfig } from "./sharedTree";

interface IDriverTree {
  filterOptions: IFilterOptions;
  selectedDrivers: string[];
  setSelectedDrivers: (items: string[]) => void;
  includeNullDriver: boolean;
  setIncludeNullDriver: (value: boolean) => void;
}

const DRIVER_TREE_CONFIG: IOptionsTreeConfig = {
  groupId: "drivers",
  ungroupedGroupId: "drivers-desagrupado",
  ungroupedItemId: "__desagrupado_driver__",
  itemType: "driver",
  icon: "rioglyph rioglyph-driver",
  groupLabel: "assetTree.driver.group",
  ungroupedItemLabel: "assetTree.driver.noItem",
  searchPlaceholder: "assetTree.driver.search",
};

const DriverTree = ({
  filterOptions,
  selectedDrivers,
  setSelectedDrivers,
  includeNullDriver,
  setIncludeNullDriver,
}: IDriverTree) => (
  <OptionsTreeWithUngrouped
    config={DRIVER_TREE_CONFIG}
    options={filterOptions?.drivers}
    selectedIds={selectedDrivers}
    setSelectedIds={setSelectedDrivers}
    includeNull={includeNullDriver}
    setIncludeNull={setIncludeNullDriver}
  />
);

export default DriverTree;
